import { useState, useEffect } from "react";
import { Pagination, Table, Tooltip, Popconfirm, message, Tag } from "antd";
import classNames from "classnames";
import styles from "./index.module.scss";
import publicImg from "@/assets/images/discover/public.png";
import unpublic from "@/assets/images/discover/unpublic.png";
import computable from "@/assets/images/discover/computable.png";
import {
  DeleteOutlined,
  FormOutlined,
  StarFilled,
  StopOutlined,
  CheckCircleOutlined,
  // ExportOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  myResourceList,
  cancelCollectResource,
  deleteResource,
  updateStatus,
} from "@/apis/discover";
import intl from "react-intl-universal";
// import { resourceUpdate } from "@/apis/audit";
const DiscoverData = ({ selectKeys, Keywords, token }) => {
  // const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const [params, setparams] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const columns = [
    {
      title: intl.get("Type"),
      key: "icon_bar",
      width: 100,
      render: (text, record, index) => (
        <div className={styles.iconBox}>
          {record.resourceType && (
            <Tooltip title={record.resourceType.typeName}>
              <img src={process.env.REACT_APP_API_AFFIX + record.resourceType.imgPath} />
            </Tooltip>
          )}
          {record.secondType !== "OpenDataServices" &&
            record.secondType !== "OpenProcessServices" &&
            record.secondType !== "OpenWebApps" && (
              <Tooltip title={record.isDownloadable ? "Downloadable" : "Not downloadable"}>
                <img src={record.isDownloadable ? publicImg : unpublic} />
              </Tooltip>
            )}
          {record.isComputable && (
            <Tooltip title={"Computable"}>
              <img src={computable} />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: intl.get("Title"),
      dataIndex: "title",
      key: "title",
      width: 230,
      render: (text, record, _index) => (
        <Tooltip
          title={<div className={styles.descriptionTooltip}>{record.description}</div>}
          placement="right"
        >
          <a
            target="_blank"
            href={`${process.env.PUBLIC_URL}/discover/detail?id=${record.resourceUuid}`}
          >
            {text ? text : "未定义"}
          </a>
        </Tooltip>
      ),
    },
    {
      title: intl.get("Contributor"),
      dataIndex: "b",
      key: "contributors",
      width: 100,
      render: (_text, record, _index) => (
        <div>
          {record.contributors && record.contributors.length > 0
            ? record.contributors[0].nickname
            : ""}
        </div>
      ),
    },
    {
      title: intl.get("Date Created"),
      dataIndex: "createTime",
      key: "dateCreated",
      width: 100,
    },
    {
      title: intl.get("Last Modifiled"),
      dataIndex: "updateTime",
      key: "lastModifiled",
      width: 100,
    },
    {
      title: intl.get("Status"),
      dataIndex: "auditStatus",
      key: "auditStatus",
      width: 80,
      render: (text, _record, _index) => (
        <Tag color={switchStatus(text).color}>{intl.get(switchStatus(text).text)}</Tag>
      ),
    },
    {
      title: intl.get("Audit Opinion"),
      dataIndex: "auditMessage",
      key: "auditMessage",
      width: 100,
    },
    {
      title: intl.get("Operation"),
      key: "company",
      width: 120,
      render: (text, record) => (
        <div className={styles.operationBox}>
          {/* {record.auditStatus === 0 && record.title && (
            <Tooltip title={intl.get("Submit for review")}>
              <Popconfirm
                title={intl.get("Submit for review")}
                description={intl.get("Are you sure to submit this resource for review")}
                onConfirm={() => upResourceStatus(record.resourceUuid)}
                okText={intl.get("Yes")}
                cancelText={intl.get("No")}
              >
                <ExportOutlined style={{ color: "#62c92f", fontSize: "18px" }} />
              </Popconfirm>
            </Tooltip>
          )} */}

          {record.createdByUser && (
            <Tooltip title={intl.get("Delete")}>
              <Popconfirm
                title={intl.get("Delete the resource")}
                style={{ width: "100px" }}
                description={intl.get("Are you sure to delete this resource")}
                onConfirm={() => confirmDelete(record.resourceUuid)}
                okText={intl.get("Yes")}
                cancelText={intl.get("No")}
              >
                <DeleteOutlined style={{ color: "#d62293", fontSize: "18px" }} />
              </Popconfirm>
            </Tooltip>
          )}
          {record.createdByUser && record.auditStatus !== 1 && (
            <Tooltip title={intl.get("Edit")}>
              <FormOutlined
                style={{ color: "#1677FF", fontSize: "18px" }}
                onClick={() => {
                  goToEditor(record.resourceUuid);
                }}
              />
            </Tooltip>
          )}
          {record.collectedByUser && (
            <Tooltip title={intl.get("Cancel collection")}>
              <Popconfirm
                title={intl.get("Cancel the collection")}
                description={intl.get("Are you sure to cancel this collection")}
                onConfirm={(e) => confirmCancel(e, record.resourceUuid)}
                okText={intl.get("Yes")}
                cancelText={intl.get("No")}
              >
                <StarFilled style={{ color: "#d62293", fontSize: "16px" }} />
              </Popconfirm>
            </Tooltip>
          )}

          {record.createdByUser && record.isPublic && (
            <Tooltip title={intl.get("Hidden resource")}>
              <Popconfirm
                title={intl.get("Hidden the resource")}
                description={intl.get("Are you sure to hidden this resource")}
                onConfirm={() => changeStatus(record.resourceUuid, false)}
                okText={intl.get("Yes")}
                cancelText={intl.get("No")}
              >
                <StopOutlined style={{ color: "#d62293", fontSize: "18px" }} />
              </Popconfirm>
            </Tooltip>
          )}
          {record.createdByUser && !record.isPublic && record.auditStatus === 2 && (
            <Tooltip title={intl.get("Public resource")}>
              <Popconfirm
                title={intl.get("Public the resource")}
                description={intl.get("Are you sure to public this resource")}
                onConfirm={() => changeStatus(record.resourceUuid, true)}
                okText={intl.get("Yes")}
                cancelText={intl.get("No")}
              >
                <CheckCircleOutlined style={{ color: "#62c92f", fontSize: "18px" }} />
              </Popconfirm>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  // const upResourceStatus = (id) => {
  //   resourceUpdate({
  //     resourceUuid: id,
  //     auditStatus: 1,
  //   }).then((res) => {
  //     message.success("Operate successfully");
  //     getMyResourceList();
  //   });
  // };

  const switchStatus = (val) => {
    let result = {
      text: "",
      color: "",
    };
    switch (val) {
      case 0:
        result = {
          text: "Draft",
          color: "magenta",
        };
        break;
      case 1:
        result = {
          text: "Pending Review",
          color: "gold",
        };
        break;
      case 2:
        result = {
          text: "Approved",
          color: "lime",
        };
        break;
      case 3:
        result = {
          text: "Rejected",
          color: "purple",
        };
        break;
      default:
        break;
    }
    return result;
  };
  // 修改资源状态
  const changeStatus = (id, status) => {
    updateStatus({
      resourceUuid: id,
      isPublic: status,
    }).then((res) => {
      message.success("Operate successfully");
      getMyResourceList();
    });
  };

  const getMyResourceList = () => {
    myResourceList({
      keywords: Keywords,
      pageParam: params,
      isCreat: selectKeys.includes("Owned by me"),
      isCollect: selectKeys.includes("Collected by me"),
    })
      .then((res) => {
        setDataSource(res.data?.records || []);
        setTotal(res.data?.total || 0);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    setparams({ currentPage: 1, pageSize: 10 });
  }, [selectKeys, Keywords]);

  useEffect(() => {
    getMyResourceList();
  }, [params, token]);

  const goToEditor = (id) => {
    navigate(`/discover/share?id=${id}`);
  };

  // 删除资源
  const confirmDelete = (id) => {
    deleteResource({
      resourceUuid: id,
    })
      .then((res) => {
        message.success("Successfully delete");
        getMyResourceList();
      })
      .catch((err) => {});
  };

  // 取消收藏
  const confirmCancel = (e, id) => {
    cancelCollectResource({
      resourceUuid: id,
    })
      .then((res) => {
        message.success("Uncollect successfully");
        getMyResourceList();
      })
      .catch((err) => {});
  };

  return (
    <div className={classNames(styles.discoverDataBox)}>
      {/*<div className={styles.btnBox}>
				{selectKeys === 'owned-by-me' &&
					<Popconfirm
						title="Delete the task"
						description="Are you sure to delete the selected task?"
						onConfirm={confirmDelete}
						okText="Yes"
						cancelText="No"
					>
						<Button disabled={selectedRowKeys.length === 0} type="primary">Batch delete</Button>
					</Popconfirm>
				}
				{selectKeys === 'collects' &&
					<Popconfirm
						title="Cancel the collection"
						description="Are you sure to cancel the selected collection?"
						onConfirm={confirmCancel}
						okText="Yes"
						cancelText="No"
					>
						<Button disabled={selectedRowKeys.length === 0} style={{ marginLeft: "20px" }} type="primary">Batch cancel collection</Button>
					</Popconfirm>
				}
			</div>*/}

      <Table
        // rowSelection={rowSelection}
        rowKey={(record) => record.resourceUuid}
        showTotal={(total) => `Total ${total} items`}
        size="small"
        scroll={{ y: "700px" }}
        pagination={false}
        dataSource={dataSource}
        columns={columns}
      />
      <Pagination
        style={{ marginTop: "20px" }}
        align="end"
        current={params.currentPage}
        pageSize={params.pageSize}
        total={total}
        showSizeChanger={false}
        onChange={(page, pageSize) => {
          setparams({
            currentPage: page,
            pageSize: pageSize,
          });
        }}
      />
    </div>
  );
};
export default DiscoverData;
